module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_adwords_call_cost-00b98a59fa3a48362914ea5d9a84bfa4.png";